import { render, staticRenderFns } from "./listRecords.vue?vue&type=template&id=ed2e05f0"
import script from "./listRecords.vue?vue&type=script&lang=js"
export * from "./listRecords.vue?vue&type=script&lang=js"
import style0 from "./listRecords.vue?vue&type=style&index=0&id=ed2e05f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports